'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the trusted Marathi Chambhar Matrimony in Maharashtra?', answer: 'In the state of Maharashtra, MarathiVadhuVarSuchak.com is the most trusted Marathi matrimony site for Chambhar brides and grooms.' },
  { question: 'Which is the best Chambhar Caste Vadhu Var Suchak in Pune?', answer: 'For the Pune-based Chambhar caste brides and grooms, MarathiVadhuVarSuchak.com is the best option for free registration.' },
  { question: 'How to search Chambhar Brides profiles online?', answer: "To search Chambhar brides' profiles online, you have to register for free through the MarathiVadhuVarSuchak.com mobile app." },
  { question: 'How to search Chambhar caste category brides and grooms?', answer: 'MarathiVadhuVarSuchak.com mobile app is the most trusted brand to search Chambhar caste category brides and grooms.' },
  { question: 'How to join Chambhar Vadhu Var WhatsApp group link?', answer: 'MarathiVadhuVarSuchak.com does not have any WhatsApp group link to join due to strict privacy policy.' },
  { question: 'How to search Chambhar caste surnames list online?', answer: 'To search Chambhar caste surnames list of brides and grooms visit MarathiVadhuVarSuchak.com Marathi matrimony.' },
  { question: 'Which is the best matrimony for Chambhar caste category in Maharashtra?', answer: 'For Chambhar caste category, MarathiVadhuVarSuchak.com Marathi matrimony is the most trusted brand.' },
  { question: 'Which is the best Marathi Chambhar Matrimony Mumbai?', answer: 'MarathiVadhuVarSuchak.com matrimonial site is the best Marathi Chambhar Matrimony in Mumbai city.' },
  { question: 'Which is the best Marathi Chambhar Matrimony Pune?', answer: 'MarathiVadhuVarSuchak.com matrimonial site is the best Marathi Chambhar Matrimony in Pune district.' },
  { question: 'How to search Chambhar caste Marathi brides and grooms?', answer: 'To search Chambhar caste Marathi brides and grooms, register free through MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search Marathi Chambhar caste Vadhu Var profiles?', answer: 'To search Marathi Chambhar caste Vadhu Var profiles, you can register free through MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'How to search grooms and brides of Chambhar caste in Maharashtra?', answer: 'In Maharashtra state, you can search grooms and brides of Chambhar caste on MarathiVadhuVarSuchak.com site.' },
  { question: 'Which is the best Chambhar Vadhu Var Suchak Mandal Pune?', answer: 'MarathiVadhuVarSuchak.com matrimony brand is the most trusted Chambhar Vadhu Var Suchak Mandal in Pune.' },
  { question: 'Which is the trusted Chambhar Vadhu Var Suchak Kendra Kolhapur?', answer: 'For Kolhapur-based Vadhu Var, MarathiVadhuVarSuchak.com is the trusted Chambhar Vadhu Var Suchak Kendra.' },
  { question: 'How to attend the Chambhar Vadhu Var Melava in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com matrimony organizes time-to-time Chambhar Vadhu Var Melava in Maharashtra. Keep visiting site for latest updates.' },
  { question: 'How to join Chambhar Vadhu Var WhatsApp group?', answer: "Because of privacy policy, 'Marathi Vadhu Var Suchak' does not have any WhatsApp group to join." },
  { question: 'Which is the best Chambhar Vadhu Var Suchak Mandal in Navi Mumbai?', answer: 'For Navi Mumbai-based Vadhu Var, MarathiVadhuVarSuchak.com is the best Chambhar Vadhu Var Suchak Mandal for free registration.' },
  { question: 'Which is the best Chambhar Vadhu Var Suchak Mandal Nashik?', answer: "'Marathi Vadhu Var Suchak' matrimonial app is the trusted Chambhar Vadhu Var Suchak Mandal in Nashik." },
  { question: 'Which is the trusted Chambhar Vadhu Var Suchak Mandal Mumbai?', answer: "For Mumbaikar Vadhu Var, 'Marathi Vadhu Var Suchak' matrimonial portal is the trusted Chambhar Vadhu Var Suchak Mandal." },
  { question: 'How to search the best Hindu Chambhar Vadhu Var Suchak Kendra?', answer: 'Visit MarathiVadhuVarSuchak.com portal if you are searching for best Hindu Chambhar Vadhu Var Suchak Kendra.' },
  { question: 'Which is the best Chambhar Vadhu Var Suchak Mandal in Dadar?', answer: "MarathiVadhuVarSuchak.com matrimony is the trusted Chambhar Vadhu Var Suchak Mandal for Dadar based brides and grooms." },
  { question: 'How to search the divorced Chambhar Vadhu photo with profiles?', answer: 'Register free on MarathiVadhuVarSuchak.com site to search the divorced Chambhar Vadhu profiles with photo.' },
  { question: 'How to search the Charmakar Chambhar Vadhu photo with profile?', answer: 'To search the Charmakar Chambhar Vadhu profiles with photo, visit MarathiVadhuVarSuchak.com matrimonial site.' },
  { question: 'How to search the Chambhar Vadhu Solapur based profiles?', answer: 'You can find Solapur-based Chambhar Vadhu profiles on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search the Chambhar Vadhu Kolhapur based matrimony profiles?', answer: 'You can find Kolhapur-based Chambhar Vadhu profiles on MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search the matrimony profiles of Chambhar grooms in Mumbai?', answer: 'To search the matrimony profiles of Chambhar grooms in Mumbai, visit MarathiVadhuVarSuchak.com matrimonial portal.' },
  { question: 'How to search the matrimony profiles of Chambhar brides Pune?', answer: 'To search the Pune-based matrimonial profiles of Chambhar brides, register free on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search the matrimony profiles of Chambhar brides Mumbai?', answer: 'To search the Mumbai-based matrimony profiles of Chambhar brides, download MarathiVadhuVarSuchak.com app to register free.' },
  { question: 'How to search the profiles of Chambhar brides Maharashtra?', answer: "In Maharashtra state, grooms can search Chambhar bride's profiles on 'Marathi Vadhu Var Suchak' matrimony." },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Chambhar Matrimony" },
  { label: "Chambhar Caste" },
  { label: "Hindu Chambhar" },
  { label: "Chambhar Brides" },
  { label: "Chambhar Caste Category" },
  { label: "Chambhar Vadhu Var WhatsApp group link" },
  { label: "Chambhar caste surnames list" },
  { label: "Chambhar caste category in Maharashtra" },
  { label: "Chambhar caste surname list" },
  { label: "Chambhar Matrimony Mumbai" },
  { label: "Chambhar Matrimony Pune" },
  { label: "Hindu Chambhar caste category" },
  { label: "Chambhar caste Marathi" },
  { label: "Marathi Chambhar caste" },
  { label: "Chambhar caste in Maharashtra" },
  { label: "Hindu Chambhar caste category in Maharashtra" },
  { label: "Hindu Chambhar caste category in Marathi" },
  { label: "Chambhar Vadhu Var Suchak Mandal Pune" },
  { label: "Chambhar Vadhu Var Suchak Kendra Kolhapur" },
  { label: "Chambhar Vadhu Var Melava" },
  { label: "Chambhar Vadhu Var WhatsApp group" },
  { label: "Chambhar Vadhu Var Suchak Mandal in Navi Mumbai" },
  { label: "Chambhar Vadhu Var Suchak Mandal Nashik" },
  { label: "Chambhar Vadhu Var Suchak Mandal Mumbai" },
  { label: "Hindu Chambhar Vadhu Var Suchak" },
  { label: "Chambhar Vadhu Var Suchak Mandal" },
  { label: "Chambhar Vadhu Var Suchak Mandal in Dadar" },
  { label: "Chambhar Vadhu Var Suchak Kendra" },
  { label: "Chambhar Vadhu Pahije" },
  { label: "Divorced Chambhar Vadhu photo" },
  { label: "Chambhar Vadhu photo" },
  { label: "Charmakar Chambhar Vadhu photo" },
  { label: "Chambhar Vadhu Solapur" },
  { label: "Chambhar Vadhu Kolhapur" },
  { label: "Chambhar grooms in Mumbai" },
  { label: "Chambhar brides" },
  { label: "Chambhar brides Pune" },
  { label: "Chambhar brides Mumbai" },
  { label: "Chambhar brides Maharashtra" },
  { label: "Charmakar Community" },
  { label: "Charmakar Samaj" },
  { label: "Charmakar Caste" },
  { label: "Charmakar Mahamandal" },
  { label: "Charmakar Vivah" },
  { label: "Charmakar Vikas Mahamandal" },
  { label: "Charmakar Vadhu Var Suchak Mandal" },
  { label: "Charmakar Vivah Mandal" },
  { label: "Charmakar Vivah Sanstha" },
];

export default function ChambharMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="चांभार (चर्मकार) समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="chambhar_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Chambhar Matrimony for Charmakar Communities"
        items={communityServices}
      />

    </div>
  );
}
